import { isPending } from '@futrli/shared-services';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { resetError } from '../../core/redux-utils/actions';
import { AuthError, StoreState } from '../../core/types';
import { FORGOT_PASSWORD } from '../constants';
import { forgotPassword } from '../redux-utils/actions';
import { getErrorSelector } from '../../core/redux-utils/selectors';
import { ForgotPasswordForm } from './forgot-password-form';

/**
 * Forgot password user page.
 */
export const ForgotPasswordFC: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, error] = useSelector((state: StoreState) => [
    isPending(state.loadingRequests.FORGOT_PASSWORD),
    getErrorSelector(state.authReducers, FORGOT_PASSWORD.ACTION)
  ]);

  const handleNewSubmit = (username: string) => {
    dispatch(forgotPassword(navigate, username));
  };

  React.useEffect(() => {
    return () => {
      dispatch(resetError(FORGOT_PASSWORD));
    };
  }, [dispatch]);

  return (
    <ForgotPasswordForm
      isLoading={isLoading as boolean}
      forgotPasswordError={error as AuthError}
      onSubmit={handleNewSubmit}
    />
  );
};

export const ForgotPassword = React.memo(ForgotPasswordFC);
